(function(){
  /* ---------- gallery thumbs (PDP) ---------- */
  var main = document.querySelector('[data-tc-main-img]');
  document.querySelectorAll('[data-tc-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      if (main){ main.src = t.dataset.full; main.srcset=''; }
      document.querySelectorAll('[data-tc-thumb]').forEach(function(x){ x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---------- PDP variant picker ---------- */
  var pdp = document.querySelector('[data-tc-pdp]');
  if (pdp){
    /* colorize swatches by name when no native swatch hex is set.
       2026-09-08: TC's live colour values are "Black", "Navy" and
       "Dark Grey Heather". The last one matched NOTHING in this map and fell
       back to var(--tc-panel-2), so a dark grey shirt showed a near-white
       swatch on every PDP. Keys are matched on the exact lowercased option
       value — add the full value, not a guess at a shorter form. */
    var COLORMAP = {black:'#0a0a0a',white:'#ffffff','off white':'#f3f1ea',natural:'#e9e2d0',sand:'#d9cdb8',cream:'#efe9d6',bone:'#e7e2d4',navy:'#1f2a44','navy blue':'#1f2a44',blue:'#2563eb',royal:'#1d4ed8','royal blue':'#1d4ed8','light blue':'#a9d4ee','carolina blue':'#8bb8e8',red:'#E8172B',cardinal:'#a4133c',maroon:'#6d1f2c',burgundy:'#5b1a2b',pink:'#e85a9b',azalea:'#e85a9b','light pink':'#f3b6cf',green:'#1f8a4c',forest:'#1f5c3a','forest green':'#1f5c3a','military green':'#4b5320',olive:'#6b6f3a',grey:'#9a9a9a',gray:'#9a9a9a','sport grey':'#b8b8bd','sport gray':'#b8b8bd','heather grey':'#b8b8bd','heather gray':'#b8b8bd','dark grey heather':'#4a4a50','dark gray heather':'#4a4a50','dark heather grey':'#4a4a50','dark heather gray':'#4a4a50','black heather':'#171719','heather black':'#171719',charcoal:'#36363a','dark heather':'#4a4a50',ash:'#d6d6d8',silver:'#c9c9cd',gold:'#d4a017',yellow:'#f4c430',orange:'#e8721c',purple:'#6d28d9',brown:'#5a3a22',tan:'#caa472',teal:'#1b8a8a'};
    pdp.querySelectorAll('.tc-swatch').forEach(function(sw){
      var hasHex = (sw.getAttribute('style')||'').indexOf('var(--tc-panel-2)') === -1;
      if (hasHex) return;
      var name = (sw.getAttribute('data-tc-name')||'').trim().toLowerCase();
      if (COLORMAP[name]) {
        sw.style.background = COLORMAP[name];
        if (name === 'white' || name === 'off white' || name === 'natural' || name === 'cream' || name === 'bone' || name === 'ash') sw.style.borderColor = '#d4d4d8';
      }
    });
    var variants = [];
    try { variants = JSON.parse(pdp.querySelector('[data-tc-variants]').textContent); } catch(e){}
    var idInput = pdp.querySelector('[data-tc-id]');
    var addBtn  = pdp.querySelector('[data-tc-add]');
    var priceEl = pdp.querySelector('[data-tc-price]');
    var payWrap = pdp.querySelector('[data-tc-paywrap]');
    var stickyPrice = document.querySelector('[data-tc-sticky-price]');
    var stickyBtn   = document.querySelector('[data-tc-sticky-add]');
    var sizeRow     = document.querySelector('[data-tc-sticky-sizes]');
    var stickySizeBtns = Array.prototype.slice.call(document.querySelectorAll('[data-tc-sticky-val]'));
    var optGroups = Array.prototype.slice.call(pdp.querySelectorAll('[data-tc-opt]'));

    /* the option position that carries size — used for the sticky fast path */
    var sizePos = null;
    optGroups.forEach(function(g){
      if (g.getAttribute('data-tc-opt-kind') === 'size') sizePos = parseInt(g.getAttribute('data-opt-pos'),10);
    });

    function selected(){
      // selected value per position (1-indexed); null when the shopper has not chosen
      var sel = [];
      optGroups.forEach(function(g){
        var pos = parseInt(g.getAttribute('data-opt-pos'),10);
        var active = g.querySelector('.is-active');
        sel[pos-1] = active ? active.getAttribute('data-tc-val') : null;
      });
      return sel;
    }
    function findVariant(sel){
      return variants.find(function(v){
        return v.options.every(function(o,i){ return sel[i] == null || o === sel[i]; });
      });
    }
    function mainBtnFor(pos, val){
      var found = null;
      pdp.querySelectorAll('[data-tc-val]').forEach(function(b){
        if (parseInt(b.getAttribute('data-tc-pos'),10) === pos && b.getAttribute('data-tc-val') === val) found = b;
      });
      return found;
    }
    function refreshAvailability(sel){
      optGroups.forEach(function(g){
        var pos = parseInt(g.getAttribute('data-opt-pos'),10);
        g.querySelectorAll('[data-tc-val]').forEach(function(btn){
          if (btn.classList.contains('tc-swatch')) return; // don't disable color swatches
          var test = sel.slice(); test[pos-1] = btn.getAttribute('data-tc-val');
          var ok = variants.some(function(v){
            return v.available && v.options.every(function(o,i){ return test[i] == null || o === test[i]; });
          });
          if (ok) { btn.removeAttribute('disabled'); } else { btn.setAttribute('disabled','disabled'); }
        });
      });
    }
    /* mirror the main option state onto the sticky-bar size row */
    function syncSticky(sel){
      stickySizeBtns.forEach(function(b){
        var pos = parseInt(b.getAttribute('data-tc-pos'),10);
        var val = b.getAttribute('data-tc-sticky-val');
        if (sel[pos-1] === val) { b.classList.add('is-active'); } else { b.classList.remove('is-active'); }
        var m = mainBtnFor(pos, val);
        if (m && m.hasAttribute('disabled')) { b.setAttribute('disabled','disabled'); }
        else { b.removeAttribute('disabled'); }
      });
    }
    function sync(){
      var sel = selected();
      refreshAvailability(sel);
      var v = findVariant(sel);
      // update per-option label
      optGroups.forEach(function(g){
        var lbl = g.querySelector('[data-tc-opt-sel]');
        var active = g.querySelector('.is-active');
        if (!lbl) return;
        if (active) {
          lbl.textContent = active.getAttribute('data-tc-name') || active.getAttribute('data-tc-val');
          lbl.classList.remove('tc-opt__req');
        } else {
          lbl.textContent = lbl.getAttribute('data-tc-empty') || 'Select';
          lbl.classList.add('tc-opt__req');
        }
      });
      var complete = optGroups.length === 0 || sel.every(function(s){ return s != null; });
      syncSticky(sel);
      if (v && v.available && complete){
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_money;
        if (stickyPrice) stickyPrice.textContent = v.price_money;
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart — ' + v.price_money;
        if (payWrap) payWrap.hidden = false;
        if (stickyBtn) stickyBtn.textContent = 'Add to Cart';
        if (sizeRow) sizeRow.classList.remove('is-warn');
      } else if (v && !v.available && complete){
        idInput.value = '';
        addBtn.disabled = true; addBtn.textContent = 'Sold Out';
        if (payWrap) payWrap.hidden = true;
        if (stickyBtn) stickyBtn.textContent = 'Sold Out';
      } else {
        /* NOTHING is selected by default — no variant may be posted until the
           shopper picks. Clearing idInput is the hard gate; the disabled button
           is the visible one. Changed 2026-08-25. */
        idInput.value = '';
        addBtn.disabled = true;
        addBtn.textContent = complete ? 'Unavailable' : 'Select a size';
        if (payWrap) payWrap.hidden = true;
        if (stickyBtn) stickyBtn.textContent = 'Select a size';
      }
    }
    pdp.querySelectorAll('[data-tc-val]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.hasAttribute('disabled')) return;
        var pos = btn.getAttribute('data-tc-pos');
        pdp.querySelectorAll('[data-tc-val][data-tc-pos="'+pos+'"]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        sync();
      });
    });
    /* sticky size row drives the same state as the main picker */
    stickySizeBtns.forEach(function(b){
      b.addEventListener('click', function(){
        if (b.hasAttribute('disabled')) return;
        var m = mainBtnFor(parseInt(b.getAttribute('data-tc-pos'),10), b.getAttribute('data-tc-sticky-val'));
        if (m && !m.hasAttribute('disabled')) m.click();
      });
    });
    if (optGroups.length) sync();

    /* ---------- bundle tiers ---------- */
    pdp.querySelectorAll('[data-tc-tier]').forEach(function(tier){
      tier.addEventListener('click', function(){
        pdp.querySelectorAll('[data-tc-tier]').forEach(function(t){ t.classList.remove('is-active'); });
        tier.classList.add('is-active');
      });
    });

    /* ---------- sticky bar ---------- */
    var sticky = document.querySelector('[data-tc-sticky]');
    if (sticky && addBtn){
      var onScroll = function(){
        var r = addBtn.getBoundingClientRect();
        if (r.bottom < 0) sticky.classList.add('is-shown'); else sticky.classList.remove('is-shown');
      };
      window.addEventListener('scroll', onScroll, { passive:true }); onScroll();
      if (stickyBtn) stickyBtn.addEventListener('click', function(){
        if (addBtn.disabled){
          /* never a silent no-op: point at the decision instead of scrolling away */
          if (sizeRow){
            sizeRow.classList.add('is-warn');
            setTimeout(function(){ sizeRow.classList.remove('is-warn'); }, 1600);
          } else {
            var box = pdp.querySelector('[data-tc-opt]');
            if (box) box.scrollIntoView({ behavior:'smooth', block:'center' });
          }
          return;
        }
        /* .click() on the real submit button keeps name="add" in the POST */
        addBtn.click();
      });
    }
  }
})();